import { Button, Col, Result, Row } from "antd";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <Row
      align={"middle"}
      justify={"center"}
      style={{ minHeight: "100vh" }}
    >
      <Col>
        <Result
          status="404"
          title="Page not found"
          subTitle="Sorry, we could not find the page you're looking for. If the problem persists, please let us know via info@root-sustainability.com. Thank you!"
          extra={
            <Link to={"/"}>
              <Button type="primary">Go home</Button>
            </Link>
          }
        />
      </Col>
    </Row>
  );
}
